export default "__VITE_ASSET__DI0ofR1M__"